import { apiAction } from '../../../core/services/http/apiAction';
import workflowConstants from './workflowConstants';
import {
  GET_INBOX_REQUEST,
  GET_INBOX_SUCCESS,
  GET_INBOX_ERROR,
  GET_REQUEST_REQUEST,
  GET_REQUEST_SUCCESS,
  GET_REQUEST_ERROR,
  DECIDE_REQUEST,
  DECIDE_SUCCESS,
  DECIDE_ERROR,
  GET_AWAITING_REQUEST,
  GET_AWAITING_SUCCESS,
  GET_AWAITING_ERROR,
} from './workflowActionTypes';

/** The Inbox page: `{ page, rowsPerPage, scope, bucket, type, status, searchTerm }`. */
export const getInbox = (params) =>
  apiAction({ types: [GET_INBOX_REQUEST, GET_INBOX_SUCCESS, GET_INBOX_ERROR], url: workflowConstants.INBOX(params) });

/**
 * The dashboard's "needs your action" card: the first few items and the total.
 * Its own action types, so opening the dashboard does not overwrite the Inbox
 * page's list (or the other way round).
 */
export const getAwaiting = (count = 5) =>
  apiAction({
    types: [GET_AWAITING_REQUEST, GET_AWAITING_SUCCESS, GET_AWAITING_ERROR],
    url: workflowConstants.INBOX({ rowsPerPage: count }),
  });

export const getRequest = (key) =>
  apiAction({
    types: [GET_REQUEST_REQUEST, GET_REQUEST_SUCCESS, GET_REQUEST_ERROR],
    url: workflowConstants.REQUEST(key),
  });

/**
 * Approve or reject in an approver role:
 * `{ role: 'HQ_FINANCE'|'DEPT_IN_CHARGE', decision: 'APPROVED'|'REJECTED', comment, confirm_red_rating }`.
 *
 * `red_rating_confirmation_required` is left to the dialog, which asks for the
 * confirmation rather than toasting an error.
 */
export const decide = (key, decision) =>
  apiAction({
    types: [DECIDE_REQUEST, DECIDE_SUCCESS, DECIDE_ERROR],
    method: 'post',
    url: workflowConstants.DECIDE(key),
    data: decision,
    toastOnSuccess: true,
    requestMeta: { isSaving: true },
    silentCodes: ['red_rating_confirmation_required'],
  });
